// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__11tJB","select":"Header_select__3cl2b","clinic":"Header_clinic__1wyT5"};